export enum OrderDeliveryStatus {
  PROCESSING = 'PROCESSING',
  DELIVERED = 'DELIVERED',
}
